import { actionTypes } from "./actions";

const initialState = {
    selectedBranches: [],
    branchAssetsCount: {},
    selectedLocations: {
        idx: [],
        ids: []
    },
    auditors: [],
    assetsToAudit: false,
    filters: {
        conditions: {
            isNew: true,
            isUsed: true
        },
        monetaryValueSampling: 0,
        randomValueSampling: 100
    },
    data: [],
    startDate: new Date(),
    endDate: new Date(new Date().setHours(23, 59, 59, 0)),
    leavingAudit: false, // when user exits the audit creation
    pendingNavigation: null,
    initError: false // step 1 data failed to load; Branches offers a retry
};

export default function (state = { ...initialState }, action) {
    switch (action.type) {
        case actionTypes.AUDIT_CREATE_ITEM_SET: {
            const { item } = action.payload;
            const newState = { ...state };
            const keys = Object.keys(item);
            keys.forEach((key) => {
                newState[key] = item[key];
            });

            return newState;
        }
        case actionTypes.AUDIT_CREATE_CLEAR_VALUES: {
            return { ...initialState };
        }
        case actionTypes.AUDITS_CREATE_SAVE_SUCCESS: {
            return { ...initialState };
        }
        case actionTypes.AUDITS_CREATE_UPDATE: {
            return { ...state, ...action.payload };
        }
        case actionTypes.AUDIT_LOCATIONS_GET_COUNT_SUCCESS: {
            const { locCount } = action.payload;

            const newData = state.data.reduce((accum, item) => {
                const newItem = { ...item };

                const locObj = locCount.find(
                    (el) =>
                        el.branchId === item.branch &&
                        el.locationId === item.location
                );

                if (locObj) newItem.assetsCount = locObj.count;

                accum.push(newItem);
                return accum;
            }, []);
            return { ...state, data: newData };
        }
        default: {
            return state;
        }
    }
}
